import { faArrowLeft, faCheck, faUndo } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, DatePicker, Modal } from "antd"
import { Dayjs } from "dayjs"
import { useEffect, useState } from "react"
import { formatSinceDateValue, parseSinceDate, shouldShowReset, SinceDateField, SinceDateOverride } from "./sinceDateOverrideModel"

type Props = {
  override: SinceDateOverride | null
  onCancel: () => void
  onSetValue: (fieldName: SinceDateField, value: string | null) => void
}

const SinceDateOverrideModal = ({ override, onCancel, onSetValue }: Props) => {
  const [date, setDate] = useState<Dayjs | null>(null)

  useEffect(() => {
    if (override) {
      setDate(parseSinceDate(override.currentDate))
    }
  }, [override])

  if (!override) {
    return null
  }

  const showReset = shouldShowReset(date, override.standardDate)

  return <Modal
    open={!!override}
    title={<span style={{ textTransform: 'capitalize' }}>Change {override.type} since date</span>}
    onCancel={onCancel}
    footer={[
      showReset && <Button key="reset" danger style={{ float: 'left' }} icon={<FontAwesomeIcon icon={faUndo} />} onClick={() => onSetValue(override.fieldName, null)}>
        Reset To Default
      </Button>,
      <Button key="cancel" icon={<FontAwesomeIcon icon={faArrowLeft} />} onClick={onCancel}>Cancel</Button>,
      <Button key="set" type="primary" icon={<FontAwesomeIcon icon={faCheck} />} onClick={() => onSetValue(override.fieldName, formatSinceDateValue(date))}>
        Set Value
      </Button>,
    ]}
  >
    <div style={{ textTransform: 'capitalize', marginBottom: 8 }}>{override.type} since date</div>
    <DatePicker value={date} onChange={setDate} format="MM/DD/YYYY" style={{ width: '100%' }} />
  </Modal>
}

export default SinceDateOverrideModal
